import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AddressAutocomplete from "../components/AddressAutocomplete";
import { io } from "socket.io-client";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import axios from "../axios";
import "../styles/vendor.css";

const VendorProducts = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user?.id;
      const baseUrl = process.env.REACT_APP_API_BASE_URL || "";

      if (!baseUrl) {
        console.error("❌ Aucun REACT_APP_API_BASE_URL défini");
        return;
      }

      if (userId) {
        axios
          .get(`${baseUrl}/api/products/vendor/${userId}`)
          .then((res) => {
            if (Array.isArray(res.data)) {
              setProducts(res.data);
            } else {
              console.error("⚠️ La réponse n’est pas un tableau :", res.data);
              setProducts([]);
            }
          })
          .catch((err) => console.error("Erreur produits vendeur :", err));
      } else {
        console.error("❌ Aucun ID utilisateur trouvé dans localStorage");
      }
    } catch (err) {
      console.error("❌ Erreur lecture localStorage :", err);
    }
  }, []);

  // ✅ Écoute temps réel via Socket.IO
  useEffect(() => {
    const socket = io(process.env.REACT_APP_API_BASE_URL || window.location.origin);

    // 🔔 Nouveau produit créé
    socket.on("productCreatedVendor", (newProduct) => {
      console.log("🆕 Nouveau produit reçu :", newProduct);
      setProducts((prev) => {
        // On vérifie qu’il appartient bien à ce vendeur
        const user = JSON.parse(localStorage.getItem("user"));
        if (newProduct.ownerId !== user?.id) return prev;
        // On évite les doublons
        if (prev.some((p) => p._id === newProduct._id)) return prev;
        return [newProduct, ...prev];
      });
      toast.success(`🆕 Nouveau produit ajouté : ${newProduct.articleName}`);
    });

    // 🔄 Produit mis à jour
    socket.on("productUpdated", (updatedProduct) => {
      console.log("🔄 Produit mis à jour reçu :", updatedProduct);

      setProducts((prev) =>
        prev.map((p) => (p._id === updatedProduct._id ? updatedProduct : p))
      );

      // 👉 Toast détaillé
      toast.success(
        `✔️ ${updatedProduct.articleName} a été mis à jour et est passé en « ${updatedProduct.status} »`
      );
    });

    // Nettoyage à la fermeture
    return () => {
      socket.off("productCreatedVendor");
      socket.off("productUpdated");
    };
  }, []);

  const handleRetourDashboard = () => {
    navigate("/Dashboard");
  };

  const token = localStorage.getItem("token");

  const handleAddressSelect = async (addr) => {
    console.log("✅ Adresse sélectionnée :", addr);
    try {
      const response = await axios.put(
        "/api/auth/update-address",
        {
          address: addr.label,
          city: addr.city,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      alert("Adresse mise à jour avec succès !");
      console.log(response.data);
    } catch (error) {
      console.error("Erreur mise à jour adresse :", error);
      alert("Erreur lors de la mise à jour de l'adresse.");
    }
  };

  return (
    <div className="vd-page">
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />

      <div className="vd-section-header">
        <button onClick={handleRetourDashboard} className="vd-btn-ghost vd-back-btn">
          ← Dashboard
        </button>
        <h2 className="vd-section-title">🛍️ Mes produits</h2>
      </div>

      {/* 🧭 Champ d’adresse automatique */}
      <div className="vd-card" style={{ marginBottom: 16 }}>
        <div className="vd-card-title" style={{ marginBottom: 10 }}>📍 Mettre à jour mon adresse</div>
        <AddressAutocomplete onSelect={handleAddressSelect} />
      </div>

      {products.length === 0 ? (
        <div className="vd-card" style={{ textAlign: "center", color: "#94A3B8" }}>
          Aucun produit pour le moment.
        </div>
      ) : (
        <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 10 }}>
          {products.map((p) => (
            <li key={p._id} className="vd-product-item">
              <span className="vd-product-name">{p.articleName}</span>
              <span className={`vd-status-badge vd-status-${p.status?.replace(/\s/g, "-")}`}>
                {p.status}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default VendorProducts;
